import { render, staticRenderFns } from "./SoshCommitments.vue?vue&type=template&id=2cf246ed&"
import script from "./SoshCommitments.vue?vue&type=script&lang=js&"
export * from "./SoshCommitments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf246ed')) {
      api.createRecord('2cf246ed', component.options)
    } else {
      api.reload('2cf246ed', component.options)
    }
    module.hot.accept("./SoshCommitments.vue?vue&type=template&id=2cf246ed&", function () {
      api.rerender('2cf246ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/SoshCommitments.vue"
export default component.exports